import { isRiver, isHighSea, } from "../../../shared/functions/booking.cruisecheck";
import { logError } from "../../../shared/functions/misc";
import Booking from "../../../shared/functions/booking";
import Context from "../shared/context";
import Config from "../../../config";
import striptags from "striptags";
import m from "mithril";
import User from "@phoenixreisen/user";
export const View = {
    view() {
        const { data } = Booking;
        const { html, urls } = Config;
        const { webtexte: wt } = Context;
        try {
            const isShip = isRiver(data) || isHighSea(data);
            return (m("article", { class: "" },
                m("div", { class: "alert alert--info alert--icon" },
                    m("i", { class: "fas fa-info-circle" }),
                    isShip
                        ? m.trust(striptags(wt?.["login__text_reise_abgesagt__schiff"], html.allowed))
                        : m.trust(striptags(wt?.["login__text_reise_abgesagt__flug"], html.allowed))),
                m("div", { class: "tr" },
                    m("button", { type: "button", class: "btn--link", onclick: () => {
                            User.logout();
                            m.route.set(urls.LOGIN, undefined, { replace: true });
                        } }, "Zur\u00FCck zur Anmeldung"))));
        }
        catch (e) {
            logError(e);
        }
    },
};
export default View;
